import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatChipsModule } from "@angular/material/chips";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { JoditAngularModule } from "jodit-angular";
import { PipesModule } from "src/app/pipes/pipes.module";
import { CommunicationFormComponent } from "./communication-form.component";
import { WhenInputModule } from "@comunicare/comunicare-angular-inputs";

@NgModule({
  declarations: [CommunicationFormComponent],
  imports: [
    CommonModule,
    JoditAngularModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    TranslateModule,
    MatButtonModule,
    MatChipsModule,
    MatInputModule,
    MatTooltipModule,
    MatIconModule,
    MatTabsModule,
    WhenInputModule,
    PipesModule,
  ],
  exports: [CommunicationFormComponent],
})
export class CommunicationFormModule {}
